import { FIELD_TYPES } from "../../domain/clinicalForms";

const isEmpty = (value) => {
  if (value === undefined || value === null || value === "") return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (
    typeof value === "object" &&
    !Array.isArray(value) &&
    value.path === undefined &&
    Object.keys(value).length === 0
  ) {
    return true;
  }
  // file fields store { path, type, file_name }
  if (typeof value === "object" && !Array.isArray(value) && "path" in value) {
    return !value.path;
  }
  return false;
};

const isSelected = (value, optValue) =>
  Array.isArray(value) ? value.includes(optValue) : value === optValue;

/**
 * Walks form sections/fields (including nested option sub-questions) and
 * returns missing required fields as { fieldId, label, sectionId, sectionTitle }.
 */
export const findMissingRequired = (sections = [], values = {}) => {
  const missing = [];

  const walkFields = (fields, section) => {
    (fields || []).forEach((field) => {
      if (!field || field.type === FIELD_TYPES.SECTION_HEADER) return;

      if (field.required && isEmpty(values[field.id])) {
        missing.push({
          fieldId: field.id,
          label: field.label || "Untitled field",
          sectionId: section.id,
          sectionTitle: section.title,
        });
      }

      // Direct nested sub-questions
      if (field.sub_questions?.length) {
        walkFields(field.sub_questions, section);
      }

      // Option-level sub-questions only when that option is selected
      if (field.options?.length) {
        const value = values[field.id];
        field.options.forEach((opt) => {
          if (
            typeof opt === "object" &&
            opt?.sub_questions?.length &&
            isSelected(value, opt.value)
          ) {
            walkFields(opt.sub_questions, section);
          }
        });
      }
    });
  };

  (sections || []).forEach((section) => {
    walkFields(section.fields || [], section);
  });

  return missing;
};

export const formatRequiredError = (missing) => {
  if (!missing?.length) return null;
  if (missing.length === 1) {
    return `Please fill in "${missing[0].label}"`;
  }
  return `Please fill in ${missing.length} required fields (e.g. "${missing[0].label}")`;
};
